<dxp-modal content-id="modal-confirm" aria-label="Confirmation modal" cancel-button=false button-position="right"
    demo="false" demo-button-text='Show Modal' modal-size="sm" close-button="true" footer-type="no-button"
    close-on-outside-click="false" (modalClose)="this.reset()" #modalConfirm>
    <div class="dxp-row dxp-bg-initial">
        <div class="dxp-bg-initial dxp-col-md-12">
            <dxp-flex-layout>
                <dxp-flex-layout-item slot="column-1" column-width-sm="12" column-width-lg="12"
                    padding-style-sm="0px 15px">
                    <p class="feature-title">{{this.modalTitle}}</p>
                </dxp-flex-layout-item>
            </dxp-flex-layout>

            <dxp-flex-layout>
                <dxp-flex-layout-item slot="column-1" column-width-sm="12" column-width-lg="12"
                    padding-style-sm="0px 15px">
                    <div class="label-content" [innerHtml]='modalText'></div>
                </dxp-flex-layout-item>
            </dxp-flex-layout>

            <div class="dxp-mt-6 dxp-mx-2">
                <dxp-flex-layout>
                    <dxp-flex-layout-item slot="column-1" column-width-sm="3" column-width-lg="3">
                        <dxp-button type="primary" button-id="btnYes" [text]="primaryButtonText" state="enabled"
                            [ariaLabel]="primaryButtonText" [buttonTitle]="primaryButtonText"
                            (click)="modalMessage.actionYes()"></dxp-button>
                    </dxp-flex-layout-item>
                    <dxp-flex-layout-item slot="column-2" column-width-sm="3" column-width-lg="3">
                        <dxp-button *ngIf="!hideSecondaryButton" type="secondary" button-id="btnNo" [text]="secondayButtonText" state="enabled"
                            [buttonTitle]="secondayButtonText" [ariaLabel]="secondayButtonText"
                            (click)=" modalMessage.actionNo()"></dxp-button>
                    </dxp-flex-layout-item>
                </dxp-flex-layout>
            </div>
        </div>
    </div>
</dxp-modal>